module.exports = __webpack_public_path__ + "img/UTWILL.d939871e.png";